<template>
  <v-card>
    <v-card-title>
      Items
      <div class="flex-grow-1"></div>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filter"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-text>
      <p v-if="errorMessage" class="red--text text-right">{{ errorMessage }}</p>

        <v-data-table
          v-if="propItems"
          :headers="propHeaders"
          :items="propItems"
          :search="search"
          :custom-filter="customSearchFilter"
          item-key="id"
          :show-expand="propShowExpand"
          class="elevation-1"
          @click:row="rowClicked">

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <pre>
                <v-row v-for="key in Object.keys(item)" :key="key">
                  <v-col class="text-right" v-if="!excludedFields.includes(key)">{{ key }}</v-col>
                  <v-col class="text-left" v-if="!excludedFields.includes(key)">{{ item[key] }}</v-col>
                </v-row>
              </pre>
            </td>
          </template>
        </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ItemsTable',

  props: ['propHeaders', 'propItems', 'propShowExpand'],

  data: () => ({
    search: '',
    excludedFields: [
      'Location',
      'Logs'
    ],
    errorMessage: ''
  }),

  methods: {
    rowClicked (item) {
      console.log('rowClicked item.id:', item.id)
      this.$router.push('/item/' + item.id)
    },

    customSearchFilter (value, search, item) {
      if (search.includes(':')) {
        const searchKey = search.split(':')[0]
        const searchVal = search.split(':')[1].trimLeft()
        const header = this.propHeaders.find(header => header.text === searchKey)

        // console.log(`searchKey: ${searchKey}`)
        // console.log(`searchVal: ${searchVal}`)
        if (header) {
          if (item[header.value] && item[header.value].includes(searchVal)) {
            return item
          }
          this.errorMessage = ''
        } else {
          this.errorMessage = `No header named ${searchKey}, keys should be exactly like the column headers`
        }
      } else {
        return item
      }
    }
  }
}
</script>
